module.exports = __webpack_public_path__ + "img/stl.405f7d77.jpg";